import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { TypeText_DE } from './text'
import { TypeText_FR } from './text_fr'
import { useCountdown } from './useCountdown'

const ShowText_DE = TypeText_DE.split('')
const ShowText_FR = TypeText_FR.split('')

function replaceSpace(char: string) {
  if (char === ' ') return '_'
  return char
}

const locales_de = {
  seconds: 'Sekunden',
  title: 'Tipp-Geschwindigkeits-Test',
  ended: 'Beendet',
  tip_mobile: 'Tippen Sie auf den Text um den Test zu beginnen!',
  tip_desktop: 'Klicken Sie auf den Text um den Test zu beginnen!',
  continue_mobile: 'Tippen Sie auf den Text um fortzufahren!',
  continue_desktop: 'Klicken Sie auf den Text um fortzufahren!',
  write: 'Schreiben Sie den Text ab.',
  restart: 'Neu starten',
  charsperminute: 'Zeichen pro Minute',
  correct: 'Davon richtig',
  wrong: 'Davon falsch',
}

const locales_fr = {
  seconds: 'secondes',
  title: 'Test de vitesse de frappe',
  ended: 'Terminé',
  tip_mobile: 'Cliquez sur le texte pour commencer le test!',
  tip_desktop: 'Cliquez sur le texte pour commencer le test!',
  continue_mobile: 'Cliquez sur le texte pour continuer!',
  continue_desktop: 'Cliquez sur le texte pour continuer!',
  write: 'Tapez le texte.',
  restart: 'Redémarrer',
  charsperminute: 'Caractères par minute',
  correct: 'Caractères corrects',
  wrong: 'Caractères faux',
}
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const ismobile = window.innerWidth < 712
  const [timer, setTimer] = useState(0)
  const [scrollPos, setScrollPos] = useState(0)
  const [ready, setReady] = useState(false)
  const [results, setResults] = useState<{
    correct: number
    wrong: number
    total: number
  }>()
  const [userInput, setUserInput] = useState('')
  const { seconds, setPause, reset } = useCountdown(60)
  const ref = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const spanRef = useRef<HTMLDivElement>(null)

  const locales = tenant && tenant.lang === 'fr' ? locales_fr : locales_de

  const ShowText = tenant && tenant.lang === 'fr' ? ShowText_FR : ShowText_DE

  useEffect(() => {
    if (seconds !== 0) return
    let total = userInput.length
    let correct = userInput.split('').filter((f, i) => f === ShowText[i]).length
    let wrong = userInput.split('').filter((f, i) => f !== ShowText[i]).length
    setUserInput('')
    setResults({ correct, wrong, total })
    setReady(false)
  }, [seconds])

  useEffect(() => {
    if (!ready) {
      setPause(true)
    } else {
      if (containerRef.current) {
        containerRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
      }
      setPause(false)
    }
  }, [ready])

  useEffect(() => {
    if (ref.current && spanRef.current) {
      let currentpos = spanRef.current.offsetTop - 40
      if (currentpos > 40) {
        console.log(currentpos)
        ref.current.scrollTop = currentpos
      }
    }
  }, [spanRef.current])

  useEffect(() => {
    if (userInput.length > (ismobile ? 60 : 110) && ref.current) {
      let rows = Math.floor(userInput.length / (ismobile ? 60 : 110))
      // ref.current.scrollTop = rows * 30
    } else if (userInput.length === 0 && ref.current) {
      // ref.current.scrollTop = 0
    }
  }, [userInput.length])

  const Text = ismobile ? TextWidthExtended : TextWidth

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <TextWidth>
        <Title>{locales.title}</Title>
      </TextWidth>
      <Text>
        <TimerRow
          ref={containerRef}
          style={{ paddingTop: '15px' }}
          className='scroll-target'
        >
          <Timer
            style={{
              backgroundColor: ready ? 'var(--red-main)' : 'var(--text-color)',
              color: ready ? '#fff' : 'var(--site-background)',
            }}
          >
            {!results && (
              <>
                {seconds}
                <span> {locales.seconds}</span>
              </>
            )}
            {results && (
              <>
                <span>{locales.ended}</span>
              </>
            )}
          </Timer>
          <StateInfo>
            {!ready && userInput.length === 0 && (
              <>{ismobile ? locales.tip_mobile : locales.tip_desktop}</>
            )}
            {!ready && userInput.length > 0 && !results && (
              <>
                {ismobile ? locales.continue_mobile : locales.continue_desktop}
              </>
            )}
            {ready && <>{locales.write}</>}
          </StateInfo>
        </TimerRow>
        <>
          <Wrapper>
            {
              <TextField
                ref={ref}
                style={{
                  border: ready
                    ? '1px solid var(--red-main)'
                    : '1px solid var(--brandblue-bright-4)',
                }}
              >
                {ShowText.map((char, i) => {
                  let add = char === ' ' ? <wbr /> : ''
                  if (userInput[i]) {
                    if (userInput[i] === char)
                      return (
                        <Correct
                          ref={i === userInput.length - 1 ? spanRef : undefined}
                        >
                          {char}
                        </Correct>
                      )
                    return (
                      <>
                        <Wrong
                          ref={i === userInput.length - 1 ? spanRef : undefined}
                        >
                          {replaceSpace(char)}
                        </Wrong>
                        {add}
                      </>
                    )
                  }
                  if (i === userInput.length && ready)
                    return (
                      <>
                        <Current
                          ref={i === userInput.length - 1 ? spanRef : undefined}
                        >
                          {char}
                        </Current>
                        {add}
                      </>
                    )
                  return (
                    <>
                      <Untyped>{char}</Untyped>
                      {add}
                    </>
                  )
                })}
              </TextField>
            }
            {!results && (
              <TextInput
                style={{ height: ready ? '100px' : '300px' }}
                value={userInput}
                onClick={(e) => {
                  let t = e.target as HTMLInputElement
                  let end = t.value.length
                  t.setSelectionRange(end, end)
                  t.focus()
                }}
                onFocus={(e) => {
                  let end = e.target.value.length
                  e.target.setSelectionRange(end, end)
                  e.target.focus()
                  setReady(true)
                }}
                onBlur={() => setReady(false)}
                onChange={(e) => {
                  setUserInput(e.target.value)
                }}
              />
            )}
          </Wrapper>
          {results && (
            <>
              <Evaluation {...results} locales={locales}/>
            </>
          )}
          <TimerRow style={{ justifyContent: 'center' }}>
            <RestartButton
              onClick={() => {
                setResults(undefined)
                setUserInput('')
                reset(60)
                if (ref.current) {
                  ref.current.scrollTop = 0
                }
              }}
            >
              {locales.restart}
            </RestartButton>
          </TimerRow>
        </>
      </Text>
    </AppContainer>
  )
}

const Title = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  line-height: 1.2em;
  font-size: 18px;
  margin-bottom: 15px;
  margin-top: 30px;
`
const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  margin-bottom: 15px;
`
const RestartButton = styled.button`
  border: 0;
  background-color: var(--button-bg);
  color: var(--site-background);

  width: 100px;
  flex: 0 0 200px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-in-out;
  letter-spacing: 0.4px;
  height: 75px;
  padding: 10px;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`
const TimerRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
`
const StateInfo = styled.div`
  flex: 0 0 calc(100% - 100px);
  font-family: var(--font-sans-serif);
  padding: 10px;
  font-size: 15px;
  line-height: 1.4em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--status-field-bg);
  color: var(--status-field-text);
`
const Timer = styled.div`
  height: 75px;
  width: 100px;
  flex: 0 0 100px;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  padding: 15px;
  font-family: var(--font-sans-serif);
  font-weight: 700;
  line-height: 1.2em;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-weight: 300;
    margin-left: 5px;
    font-size: 15px;
  }
`
const Letter = styled.span`
  color: var(--textfield-text);
`

const Untyped = styled(Letter)``
const Current = styled(Letter)`
  color: var(--brandblue-main);
  background-color: var(--orange-bright-2);
`
const Correct = styled(Letter)`
  font-weight: 700;
  color: var(--blue-main);
`
const Wrong = styled(Letter)`
  font-weight: 700;

  color: var(--red-main);
`
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  * {
    box-sizing: border-box;
  }
`
const TextInput = styled.textarea.attrs({ type: 'text' })`
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid #0f0;
  opacity: 0;
  min-height: 100px;
  font-size: 18px;
  font-family: monospace;
  line-height: 30px;
  padding: 15px;
  vertical-align: top;
  width: 100%;
  @media screen and (max-width: 711px) {
    width: 100%;
  }
`
const TextField = styled.div`
  position: relative;
  font-family: monospace;
  display: inline-block;
  max-width: 100%;
  white-space: break-space;
  height: 300px;
  overflow: hidden;
  padding: 15px;

  width: 100%;
  margin-bottom: 15px;

  @media screen and (max-width: 711px) {
    width: 100%;
  }
`

const Evaluation = ({
  total,
  correct,
  wrong,
  locales
}: {
  total: number
  correct: number
  wrong: number
  locales: { [key: string]: string }
}) => {
  return (
    <EvaluationRoot>
      <EvaluationTotal>
        {locales.charsperminute}:<b>{total}</b>
      </EvaluationTotal>
      <EvaluationValues style={{ backgroundColor: 'var(--blue-main)' }}>
      {locales.correct}: {correct}
      </EvaluationValues>
      <EvaluationValues style={{ backgroundColor: 'var(--red-main)' }}>
      {locales.wrong}: {wrong}
      </EvaluationValues>
    </EvaluationRoot>
  )
}

const EvaluationRoot = styled.div`
  color: #fff;
  background-color: var(--text-color);
  color: var(--site-background);
  font-family: var(--font-sans-serif);
  padding: 15px;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  font-weight: 300;
  text-align: center;
  b {
    margin-left: 10px;
    font-size: 26px;
  }
`
const EvaluationTotal = styled.div`
  flex: 0 0 100%;
  padding-top: 5px;
  padding-bottom: 15px;
`

const EvaluationValues = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
  flex: 0 0 50%;
  @media screen and (max-width: 711px) {
    flex: 0 0 100%;
  }
`
export default MainComponent
